import http from "./http-common";

class IcuWardService {
  WardPatientList(payload = {}) {
    const queryString = Object.entries(payload || {})
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return http.get(
      queryString
        ? `/ipdAdmission/ward-patient-list?${queryString}`
        : `/ipdAdmission/ward-patient-list`
    );
  }

  getWardPatientList(payload = {}) {
    return this.WardPatientList(payload);
  }
}

export default new IcuWardService();
